export const Experiments = {
  b2c_059_donate_to_yourself_v3: 'b2c_059_donate_to_yourself_v3',
};
